import {Routes} from '@angular/router';
import {
    LoginFormComponent,
    ResetPasswordFormComponent,
    ChangePasswordFormComponent,
} from './components';
import {AuthGuardService} from '@services';

import {SideNavOuterToolbarComponent, UnauthenticatedContentComponent} from './layouts';
import {EmployeesComponent} from "./pages/attendance/employees/employees.component";
import {ShiftsComponent} from "./pages/settings/shifts/shifts.component";
import {RolesComponent} from "./pages/settings/roles/roles.component";
import {EditRoleFormComponent} from "./pages/settings/roles/edit-role-form/edit-role-form.component";
import {FileImportComponent} from "./pages/file-import/file-import.component";
import {TimeLogsComponent} from "./pages/attendance/time-logs/time-logs.component";
import {HuddlesComponent} from "./pages/attendance/huddles/huddles.component";
import {MyScoreComponent} from "./pages/attendance/my-score/my-score.component";
import {EmployeeComponent} from "./pages/attendance/employee/employee.component";
import {ScheduleComponent} from "./pages/attendance/schedule/schedule.component";
import {TimeOffTabsComponent} from "./pages/attendance/time-off/time-off-tabs/time-off-tabs.component";
import {UsersComponent} from "./pages/settings/users/users.component";
import {ChangeRequestsComponent} from "./pages/attendance/change-requests/change-requests.component";
import {EmailTemplatesComponent} from "./pages/settings/email-templates/email-templates.component";
import {EmailLogsComponent} from "./pages/settings/email-logs/email-logs.component";
import {AssetsComponent} from "./pages/safety/assets/assets.component";
import {AssetDetailsComponent} from "./pages/safety/assets/asset-details/asset-details.component";
import {ChecklistsComponent} from "./pages/safety/checklists/checklists.component";
import {ChecklistDetailsComponent} from "./pages/safety/checklists/checklist-details/checklist-details.component";
import {ChecklistMyScoreComponent} from "./pages/safety/checklist-my-score/checklist-my-score.component";
import {MaterialsComponent} from "./pages/inventory/materials/materials.component";
import {MaterialDetailsComponent} from "./pages/inventory/materials/material-details/material-details.component";
import {BinsComponent} from "./pages/inventory/bins/bins.component";
import {BinDetailsComponent} from "./pages/inventory/bins/bin-details/bin-details.component";
import {HalbsComponent} from "./pages/inventory/halbs/halbs.component";
import {HalbDetailsComponent} from "./pages/inventory/halbs/halb-details/halb-details.component";
import {FacilityCapacityComponent} from "./pages/inventory/facility-capacity/facility-capacity.component";
import {IncidentReportComponent} from './pages/safety/incident-reports/incident-reports.component';
import {IncidentReportDetailsComponent} from './pages/safety/incident-reports/incident-report-details/incident-report-details.component';
import {StorageUnitsComponent} from "./pages/inventory/storage-units/storage-units.component";
import {StorageUnitDetailsComponent} from "./pages/inventory/storage-units/storage-unit-details/storage-unit-details.component";
import {DurationSettingsComponent} from "./pages/inventory/duration-settings/duration-settings.component";
import {StorageUnitsByBinComponent} from "./pages/inventory/storage-units-by-bin/storage-units-by-bin.component";
import {InventoryUtilizationComponent} from "./pages/inventory/inventory-utilization/inventory-utilization.component";
import {SuppliersComponent} from './pages/inbound/suppliers/suppliers.component';
import {CarriersComponent} from './pages/inbound/carriers/carriers.component';
import {AppointmentsComponent} from './pages/inbound/appointments/appointments.component';
import {AppointmentComponent} from './pages/inbound/appointments/appointment/appointment.component';
import {PurchaseOrdersComponent} from "./pages/inbound/purchase-orders/purchase-orders.component";
import {PurchaseOrderComponent} from "./pages/inbound/purchase-orders/purchase-order/purchase-order.component";
import {EmptyCheckInsComponent} from './pages/inbound/empty-check-ins/empty-check-ins.component';
import {EmptyCheckInComponent} from './pages/inbound/empty-check-ins/empty-check-in/empty-check-in.component';
import {AppointmentCalendarComponent} from './pages/inbound/appointment-calendar/appointment-calendar.component';
import {EmptyCheckOutsComponent} from './pages/outbound/empty-check-outs/empty-check-outs.component';
import {EmptyCheckOutComponent } from './pages/outbound/empty-check-outs/empty-check-out/empty-check-out.component';
import {ShuntMovesComponent} from './pages/yard-management/shunt-management/shunt-moves.component';
import {BlockedStockComponent} from "./pages/inventory/blocked-stock/blocked-stock.component";
import {YardCapacityComponent} from './pages/yard-management/yard-capacity/yard-capacity.component';
import {NextViewComponent} from './pages/productivity/next-view/next-view.component';
import {YearToDateComponent} from './pages/productivity/year-to-date/year-to-date.component';
import {PerformanceComponent} from './pages/productivity/performance/performance.component';
import {MB51Component} from "./pages/inventory/mb51/mb51.component";
import {ProductivitySettingsComponent} from './pages/settings/productivity-settings/productivity-settings.component';
import {VendorsComponent} from './pages/Invoicing/vendors/vendors.component';
import {OrdersComponent} from "./pages/outbound/orders/orders.component";
import {OrderComponent} from "./pages/outbound/orders/order/order.component";
import {LoadComponent} from "./pages/outbound/orders/load/load.component";
import {CustomersComponent} from "./pages/outbound/customers/customers.component";
import {OutboundMyScoreComponent} from "./pages/outbound/my-score/my-score.component";
import {InvoicingMyScoreComponent} from './pages/Invoicing/my-score/my-score.component';
import {InvoicePurchaseOrdersComponent} from './pages/Invoicing/invoice-purchase-orders/invoice-purchase-orders.component';
import {InvoicePurchaseOrderComponent} from './pages/Invoicing/invoice-purchase-orders/invoice-purchase-order/invoice-purchase-order.component';
import {ServiceTypesComponent} from './pages/settings/service-types/service-types.component';
import {GlCodeComponent} from './pages/settings/gl-code/gl-code.component';
import {ConversionRatesComponent} from './pages/settings/conversion-rates/conversion-rates.component';
import {MustDepartTimesComponent} from './pages/settings/must-depart-times/must-depart-times.component';
import { YardScoreComponent } from './pages/yard-management/yard-score/yard-score.component';
import {InvoicesComponent} from './pages/Invoicing/invoices/invoices.component';
import {InvoiceComponent} from './pages/Invoicing/invoices/invoice/invoice.component';
import { CreditRequestsComponent } from './pages/Invoicing/credit-requests/credit-requests.Component';
import { CreditRequestComponent } from './pages/Invoicing/credit-requests/credit-request/credit-request.component';
import { AppointmentScoreComponent } from './pages/inbound/appointment-score/appointment-score.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';


export const routes: Routes = [
    {
        path: 'auth',
        component: UnauthenticatedContentComponent,
        children: [
            {
                path: 'sign-in',
                component: LoginFormComponent
            },
            {
                path: 'reset-password',
                component: ResetPasswordFormComponent
            },
            {
                path: 'change-password/:recoveryCode',
                component: ChangePasswordFormComponent
            },
            ...[
                {from: 'create-account', to: 'register'},
                {from: 'login', to: 'sign-in'},
            ].map(redirect => ({path: redirect.from, redirectTo: redirect.to, pathMatch: 'full' as const})),
            {
                path: '**',
                redirectTo: 'sign-in',
                pathMatch: 'full',
            },
        ]
    },
    {
        path: '',
        component: SideNavOuterToolbarComponent,
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'file-imports',
                component: FileImportComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'me',
                component: EmployeeComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'employee/:employeeId',
                component: EmployeeComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'employees',
                component: EmployeesComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'shifts',
                component: ShiftsComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'roles',
                component: RolesComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'role/:roleId',
                component: EditRoleFormComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'time-logs',
                component: TimeLogsComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'huddle',
                component: HuddlesComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'my-score',
                component: MyScoreComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'scheduler',
                component: ScheduleComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'time-off',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: '',
                        component: TimeOffTabsComponent
                    },
                    {
                        path: ':tab',
                        component: TimeOffTabsComponent
                    },
                    {
                        path: ':tab/:requestId',
                        component: TimeOffTabsComponent
                    }
                ]
            },
            {
                path: 'users',
                component: UsersComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'change-requests',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: '',
                        component: ChangeRequestsComponent
                    },
                    {
                        path: ':requestId',
                        component: ChangeRequestsComponent
                    }
                ]
            },
            {
                path: 'email-templates',
                component: EmailTemplatesComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'email-logs',
                component: EmailLogsComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'assets',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: '',
                        component: AssetsComponent,
                    },
                    {
                        path: 'create',
                        component: AssetDetailsComponent,
                    },
                    {
                        path: 'edit/:assetId',
                        component: AssetDetailsComponent,
                    }
                ]
            },
            {
                path: 'checklist',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: '',
                        component: ChecklistsComponent,
                    },
                    {
                        path: 'create',
                        component: ChecklistDetailsComponent,
                    },
                    {
                        path: 'edit/:id',
                        component: ChecklistDetailsComponent,
                    }
                ]
            },
            {
                path: 'checklist-my-score',
                component: ChecklistMyScoreComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'incident-report',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: '',
                        component: IncidentReportComponent,
                    },
                    {
                        path: 'create',
                        component: IncidentReportDetailsComponent,
                    },
                    {
                        path: 'edit/:id',
                        component: IncidentReportDetailsComponent,
                    }
                ]
            },
            {
                path: 'inbound',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: 'appointment-calendar',
                        component: AppointmentCalendarComponent
                    },
                    {
                        path: 'appointment-score',
                        component: AppointmentScoreComponent
                    },
                    {
                        path: 'appointments',
                        component: AppointmentsComponent
                    },
                    {
                        path: 'appointments/details/:number',
                        component: AppointmentComponent
                    },
                    {
                        path: 'appointments/create',
                        component: AppointmentComponent,
                    },
                    {
                        path: 'empty-check-ins',
                        component: EmptyCheckInsComponent
                    },
                    {
                        path: 'empty-check-ins/details/:number',
                        component: EmptyCheckInComponent
                    },
                    {
                        path: 'empty-check-ins/create',
                        component: EmptyCheckInComponent,
                    },
                    {
                        path: 'suppliers',
                        component: SuppliersComponent
                    },
                    {
                        path: 'carriers',
                        component: CarriersComponent
                    },
                    {
                        path: 'purchase-orders',
                        component: PurchaseOrdersComponent
                    },
                    {
                        path: 'purchase-orders/details/:number',
                        component: PurchaseOrderComponent
                    },
                ]
            },
            {
                path: 'outbound',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: 'my-score',
                        component: OutboundMyScoreComponent
                    },
                    {
                        path: 'empty-check-outs',
                        component: EmptyCheckOutsComponent
                    },
                    {
                        path: 'empty-check-outs/details/:number',
                        component: EmptyCheckOutComponent
                    },
                    {
                        path: 'orders',
                        component: OrdersComponent
                    },
                    {
                        path: 'orders/details/:number',
                        component: OrderComponent
                    },
                    {
                        path: 'orders/load/details/:number',
                        component: LoadComponent
                    },
                    {
                        path: 'orders/:tab',
                        component: OrdersComponent
                    },
                    {
                        path: 'customers',
                        component: CustomersComponent
                    }
                ]
            },
            {
                path: 'yard-management',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: 'yard-score',
                        component: YardScoreComponent
                    },
                    {
                        path: 'yard-capacity',
                        component: YardCapacityComponent
                    },
                    {
                        path: 'shunt-management',
                        component: ShuntMovesComponent
                    }
                ]
            },
            {
                path: 'invoicing',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: 'my-score',
                        component: InvoicingMyScoreComponent
                    },
                    {
                        path: 'purchase-orders',
                        component: InvoicePurchaseOrdersComponent
                    },
                    {
                        path: 'purchase-orders/details/:number',
                        component: InvoicePurchaseOrderComponent
                    },
                    {
                        path: 'purchase-orders/create',
                        component: InvoicePurchaseOrderComponent,
                    },
                    {
                        path: 'invoices',
                        component: InvoicesComponent,
                    },
                    {
                        path: 'invoices/details/:number',
                        component: InvoiceComponent,
                    },
                    {
                        path: 'invoices/create',
                        component: InvoiceComponent,
                    },
                    {
                        path: 'credit-requests',
                        component: CreditRequestsComponent,
                    },
                    {
                        path: 'credit-requests/details/:number',
                        component: CreditRequestComponent,
                    },
                    {
                        path: 'credit-requests/create',
                        component: CreditRequestComponent,
                    },
                    {
                        path: 'vendors',
                        component: VendorsComponent
                    },
                ]
            },
            {
                path: 'gl-codes',
                component: GlCodeComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'service-types',
                component: ServiceTypesComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'conversion-rates',
                component: ConversionRatesComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'must-depart-times',
                component: MustDepartTimesComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'productivity',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: 'performance',
                        component: PerformanceComponent
                    },
                    {
                        path: 'efficiency',
                        component: NextViewComponent
                    },
                    {
                        path: 'year-to-date',
                        component: YearToDateComponent
                    },
                ]
            },
            {
                path: 'productivity-settings',
                component: ProductivitySettingsComponent,
                canActivate: [AuthGuardService]
            },
            {
                path: 'inventory',
                canActivate: [AuthGuardService],
                children: [
                    {
                        path: 'materials',
                        component: MaterialsComponent
                    },
                    {
                        path: 'materials/details/:number',
                        component: MaterialDetailsComponent
                    },
                    {
                        path: 'halb',
                        component: HalbsComponent
                    },
                    {
                        path: 'halb/details/:number',
                        component: HalbDetailsComponent
                    },
                    {
                        path: 'storage-bins',
                        component: BinsComponent
                    },
                    {
                        path: 'storage-bins/details/:number',
                        component: BinDetailsComponent
                    },
                    {
                        path: 'facility-capacity',
                        component: FacilityCapacityComponent
                    },
                    {
                        path: 'storage-units',
                        component: StorageUnitsComponent
                    },
                    {
                        path: 'storage-units/details/:number',
                        component: StorageUnitDetailsComponent
                    },
                    {
                        path: 'damaged',
                        component: StorageUnitsByBinComponent,
                        data: { binType: '210', title: '210 Damaged' }
                    },
                    {
                        path: 'missing',
                        component: StorageUnitsByBinComponent,
                        data: { binType: '216', title: '216 Missing' }
                    },
                    {
                        path: 'putaway',
                        component: StorageUnitsByBinComponent,
                        data: { binType: '260', title: '260 Putaway' }
                    },
                    {
                        path: 'cycle-count',
                        component: StorageUnitsByBinComponent,
                        data: { binType: '999', title: '999 Cycle Count' }
                    },
                    {
                        path: 'refill',
                        component: StorageUnitsByBinComponent,
                        data: { binType: 'LT22', title: 'LT22 Refill' }
                    },
                    {
                        path: 'utilization',
                        component: InventoryUtilizationComponent,
                    },
                    {
                        path: 'sla',
                        component: DurationSettingsComponent
                    },
                    {
                        path: 'blocked-stock',
                        children: [
                            {
                                path: '',
                                component: BlockedStockComponent
                            },
                            {
                                path: ':tab',
                                component: BlockedStockComponent
                            }
                        ]
                    },
                    {
                        path: 'mb51',
                        children: [
                            {
                                path: '',
                                component: MB51Component
                            },
                            {
                                path: ':tab',
                                component: MB51Component
                            }
                        ]
                    },
                ]
            },
            ...[
                {from: 'analytics-sales-report', to: 'analytics-sales-analysis'},
                {from: 'sign-up-form', to: 'register-form'},
            ].map(redirect => ({path: redirect.from, redirectTo: redirect.to, pathMatch: 'full' as const})),
            {
                path: '**',
                redirectTo: '/my-score',
                pathMatch: 'full',
            },
        ]
    },
];
